import { render, staticRenderFns } from "./ListImages.vue?vue&type=template&id=36cd067b&scoped=true&"
import script from "./ListImages.vue?vue&type=script&lang=js&"
export * from "./ListImages.vue?vue&type=script&lang=js&"
import style0 from "./ListImages.vue?vue&type=style&index=0&id=36cd067b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cd067b",
  null
  
)

export default component.exports